module.exports = __webpack_public_path__ + "static/media/carousel2.41f1c12b.webp";